import { render, staticRenderFns } from "./OrganizationVariableForm.vue?vue&type=template&id=e93004d6&"
import script from "./OrganizationVariableForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationVariableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports